import { rem } from "polished";
import styled from "styled-components";

import { ColorLabels } from "@/components/editor/utils/use-color";

const StyledSponsorCard = styled.div`
  width: 100%;
  margin: 0 ${rem(12)} ${rem(24)} ${rem(12)};
`;

const CardContainer = styled.div`
  background: ${({ theme }) => theme.colors[ColorLabels.BACKGROUND]};
  border: 2px solid ${({ theme }) => theme.colors[ColorLabels.VISUALS]};
  height: 0;
  padding-bottom: 50%;
  position: relative;
`;

const SponsorCardLink = styled.a`
  position: absolute;
  inset: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const CardContent = styled.div`
  padding: 6% 8%;
  max-height: 100%;
  display: flex;
`;

const Logo = styled.img`
  max-width: 100%;
  object-fit: scale-down;
`;

export { CardContainer, CardContent, SponsorCardLink, Logo, StyledSponsorCard };
